module.exports = (__webpack_require__(9))(1099);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/antd/es/switch/index.js from dll-reference antd_library
// module id = 1030
// module chunks = 42